<script setup lang="ts">
import { PortfolioElementLiquidity } from '@sonarwatch/portfolio-core';
import PortfolioBodyElementBase from './PortfolioBodyElementBase.vue';
import BaseValue from '@/components/BaseValue.vue';
import BaseYields from '@/components/BaseYields.vue';
import BaseAssetFromAssets from '@/components/BaseAssetFromAssets.vue';
import BaseAmountFromAssets from '@/components/BaseAmountFromAssets.vue';
import BaseAssetFromAsset from '@/components/BaseAssetFromAsset.vue';
import BaseAmountFromAsset from '@/components/BaseAmountFromAsset.vue';
import { TagDetails } from '@/types';
import { computed } from 'vue';
const props = defineProps<{
  element: PortfolioElementLiquidity;
  owner?: string;
}>();

const tags = computed(() => {
  const tags: TagDetails[] = [];
  if (props.element.tags?.includes('Out Of Range')) {
    tags.push({
      text: 'Out Of Range',
      icon: 'mdi-alert-circle-outline',
      color: 'warning',
    });
  }
  return tags;
});
</script>

<template>
  <PortfolioBodyElementBase
    :label="element.label"
    :network-id="element.networkId"
    :owner="owner"
    :tags="tags"
  >
    <template #header>
      <span>
        {{ element.name }}
      </span>
    </template>
    <template #default>
      <v-table hover>
        <template
          v-if="element.data.liquidities.some((l) => l.assets.length !== 0)"
        >
          <thead>
            <tr>
              <th class="text-left">Asset</th>
              <th class="text-left">Balance</th>
              <th class="text-right">Value</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(liquidity, i) in element.data.liquidities" :key="i">
              <td class="text-left">
                <div class="d-flex align-center">
                  <BaseAssetFromAssets
                    :assets="liquidity.assets"
                    :label="liquidity.name"
                  />
                  <BaseYields
                    class="ml-2"
                    :yields="liquidity.yields"
                    size="x-small"
                  ></BaseYields>
                </div>
              </td>
              <td class="text-left">
                <BaseAmountFromAssets :assets="liquidity.assets" />
              </td>
              <td class="text-right">
                <BaseValue :value="liquidity.assetsValue" />
              </td>
            </tr>
          </tbody>
        </template>
        <template
          v-if="
            element.data.liquidities.some((l) => l.rewardAssets.length !== 0)
          "
        >
          <thead>
            <tr>
              <th class="text-left">Rewards</th>
              <th class="text-left">Balance</th>
              <th class="text-right">Value</th>
            </tr>
          </thead>
          <tbody>
            <template
              v-for="(liquidity, i) in element.data.liquidities"
              :key="i"
            >
              <tr v-for="(asset, j) in liquidity.rewardAssets" :key="j">
                <td class="text-left">
                  <BaseAssetFromAsset :asset="asset" />
                </td>
                <td class="text-left">
                  <BaseAmountFromAsset :asset="asset" />
                </td>
                <td class="text-right">
                  <BaseValue :value="asset.value" />
                </td>
              </tr>
            </template>
          </tbody>
        </template>
      </v-table>
    </template>
  </PortfolioBodyElementBase>
</template>
